import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupVpaCombinedPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/vpa/points-combined.hbs" })